import { Button, Modal, Paper, Slide, Typography } from '@material-ui/core'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

import { getDirection, getTranslate } from '../../localization'
import useStyles from './index.styles'

export interface ChangeModalProps {
  title?: string
  isOpen: boolean
  onClose: () => void
  onClick: () => void
  changesFrom?: string
  changesTo?: string
}

export const ChangeModal: React.FC<ChangeModalProps> = ({
  title,
  isOpen,
  onClose,
  onClick,
  changesFrom,
  changesTo
}) => {
  const classes = useStyles()

  return (
    <Modal open={isOpen} onClose={onClose} dir={getDirection()}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <div className={classes.header}>
            <WarningRoundedIcon className={classes.icon} />
            <Typography variant="h4" className={classes.title}>
              {title
                ? title
                : getTranslate(
                    `The Payment Method Is Being Changed From ${changesFrom} To ${changesTo}`
                  )}
            </Typography>
            <Typography variant="h5" className={classes.subTitle}>
              {getTranslate('Are you sure you want to change?')}
            </Typography>
          </div>
          <div className={classes.buttonsContainer}>
            <Button variant="text" color="primary" onClick={onClose}>
              <Typography variant="h5" className={classes.cancelText}>
                {getTranslate('Cancel')}
              </Typography>
            </Button>
            <Button
              variant="contained"
              className={classes.deleteButton}
              onClick={onClick}
              color="primary">
              <Typography variant="h5" className={classes.changeText}>
                {getTranslate('Change')}
              </Typography>
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
